export const USER_CONSTANT = {
    // テーブル名
    TABLE: 'item',
    CSV_FILENAME: '資材一覧'
  };
  